/**
 * OrganizationsListItem
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Card } from 'semantic-ui-react';
import { push } from 'connected-react-router';

// Actions
import { AppState } from 'services/types';
// @ts-ignore
import { loadUsersMe } from 'services/usersMe/actions';
// @ts-ignore
import { setCurrentOrganizationId } from '../../../../../../services/currentOrganizationId/actions';
// @ts-ignore
import { setCurrentSeasonId } from '../../../../../../services/currentSeasonId/actions';

// Components
// @ts-ignore
import OrganizationName from '../../../../../../components/OrganizationName';
// @ts-ignore
import CurrentOrganizationCardMeta from './components/CurrentOrganizationCardMeta';

// Selectors
// @ts-ignore
import { makeSelectOrganizationsLatestSeasonId } from './selectors';
// @ts-ignore
import { deleteQueryString } from '../../../../../../services/router/actions';

interface OwnProps {
    organizationId: string;
}

interface ConnectedProps {
    organizationsLatestSeasonId: number;
}

interface DispatchProps {
    setCurrentOrganizationId: Function;
    setCurrentSeasonId: Function;
    deleteQueryString: Function;
    loadUsersMe: Function;
    push: Function;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class OrganizationsListItem extends React.PureComponent<Props> {
    handleClick = (): void => {
        const { organizationId, organizationsLatestSeasonId } = this.props;

        // TODO fix race condition
        this.props.deleteQueryString();
        this.props.setCurrentOrganizationId(organizationId);
        this.props.setCurrentSeasonId(organizationsLatestSeasonId);
        this.props.loadUsersMe();
        this.props.push('/organization');
    };

    render(): React.ReactElement {
        const { organizationId } = this.props;

        return (
            <Card centered onClick={this.handleClick}>
                <Card.Content>
                    <Card.Header>
                        <OrganizationName organizationId={organizationId} />
                    </Card.Header>
                    <CurrentOrganizationCardMeta
                        organizationId={organizationId}
                    />
                </Card.Content>
            </Card>
        );
    }
}
const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    organizationsLatestSeasonId: makeSelectOrganizationsLatestSeasonId()
});

export default connect(mapStateToProps, {
    setCurrentOrganizationId,
    setCurrentSeasonId,
    push,
    deleteQueryString,
    loadUsersMe
})(OrganizationsListItem);
